import { ExamQuestionType, Question } from "@types"
import { SingleChoiceOption } from "./options/SingleChoiceOption"
import { MultipleChoiceOption } from "./options/MultipleChoiceOption"
import { ImageOption } from "./options/ImageOption"
import { CorrectIncorrectOption } from "./options/CorrectIncorrectOption"
import { EssayOption } from "./options/EssayOption"
import { MultipleImageOption } from "./options/MultipleImageOption"
import { ConnectingOption } from "./options/ConnectingOption"

interface LayoutOptions {
    onApplyAISuggestion?: (points: number) => void;
}

export const chooseQuestionTypeLayout = (clickedQuestion?: Question, options?: LayoutOptions) => {

    if (clickedQuestion?.questionType.id === ExamQuestionType.SingleChoice) {
        return <SingleChoiceOption question={clickedQuestion} key={"single"}/>
    } else if (clickedQuestion?.questionType.id  === ExamQuestionType.MultipleChoices) {
        return <MultipleChoiceOption question={clickedQuestion} key={"multiple"}/>
    } else if (clickedQuestion?.questionType.id  === ExamQuestionType.ImageChoice) {
        return <ImageOption question={clickedQuestion} key={"image"}/>
    } else if (clickedQuestion?.questionType.id  === ExamQuestionType.CorrectIncorrect) {
        return <CorrectIncorrectOption question={clickedQuestion} key={"correct"}/>
    } else if (clickedQuestion?.questionType.id  === ExamQuestionType.EssayQuestion || clickedQuestion?.questionType.id  === ExamQuestionType.ShortAnswer) {
        return <EssayOption 
            question={clickedQuestion} 
            key={"essay"}
            onApplyAISuggestion={options?.onApplyAISuggestion}
        />
    } else if (clickedQuestion?.questionType.id  === ExamQuestionType.ImageMultipleChoice) {
        return <MultipleImageOption question={clickedQuestion} key={"multipleImage"}/>
    } else if (clickedQuestion?.questionType.id  === ExamQuestionType.Connecting) {
        return <ConnectingOption question={clickedQuestion} key={"matching"}/>
    }
}